import ClassicTemplate from './ClassicTemplate';
import ModernTemplate from './ModernTemplate';

// Registre des modèles de facture disponibles.
// `defaultAccent` est la couleur d'accent par défaut (surchargée par branding.brandColor).
export const INVOICE_TEMPLATES = [
  {
    id: 'classic',
    name: 'Classique',
    description: 'Bandeau vert & en-tête sombre',
    defaultAccent: '#A8D24A',
    Component: ClassicTemplate,
  },
  {
    id: 'modern',
    name: 'Moderne',
    description: 'Sidebar sombre, épuré',
    defaultAccent: '#22c55e',
    Component: ModernTemplate,
  },
];

export const getTemplate = (id) =>
  INVOICE_TEMPLATES.find((t) => t.id === id) || INVOICE_TEMPLATES[0];

// Palette de couleurs d'accent proposées dans le sélecteur.
export const ACCENT_SWATCHES = [
  '#A8D24A', '#22c55e', '#0ea5e9', '#6366f1', '#ec4899', '#f59e0b', '#ef4444', '#14b8a6',
];
